// 美味しいお茶の淹れ方ページ、img with txtのcontent
document.addEventListener("DOMContentLoaded", function() {
  const paragraphs = document.querySelectorAll(
    "#page-how_to_brew_delicious_tea .image-with-text--content--inner .rte p"
  );

  paragraphs.forEach(p => {
    const text = p.textContent.trim();

    // 最初の【までを説明文として取り出す
    const firstBracketIndex = text.indexOf("【");
    let introText = "";
    let detailText = "";

    if (firstBracketIndex !== -1) {
      introText = text.substring(0, firstBracketIndex).trim();
      detailText = text.substring(firstBracketIndex).trim();
    } else {
      introText = text; // 【がなければ全体をpに
    }

    // 新しい要素を格納するコンテナ
    const container = document.createElement("div");
    container.className = "tea-notes-wrap";

    // intro 部分を <p>
    if (introText) {
      const introP = document.createElement("p");

      // 「|」が含まれていれば span で囲む
      if (introText.includes("|")) {
        const [before, after] = introText.split("|", 2);
        introP.innerHTML = `${before}<span class="after-pipe">${after}</span>`;
      } else {
        introP.textContent = introText;
      }

      container.appendChild(introP);
    }

    // detail 部分を <dl>
    if (detailText) {
      const parts = detailText.split("【").filter(Boolean);
      const dl = document.createElement("dl");
      dl.className = "tea-notes";

      parts.forEach(part => {
        const [dtText, ddText] = part.split("】");
        if (dtText && ddText) {
          const dt = document.createElement("dt");
          dt.textContent = dtText.trim();

          const dd = document.createElement("dd");
          // 「・」で分割して改行
          const items = ddText.split("・").filter(Boolean);
          if (items.length > 1) {
            dd.innerHTML = items.map(i => "・" + i.trim()).join("<br>");
          } else {
            dd.textContent = ddText.trim();
          }

          dl.appendChild(dt);
          dl.appendChild(dd);
        }
      });

      container.appendChild(dl);
    }

    // 元の p を置換
    p.replaceWith(container);
  });
});



// 卸サンプルフォーム用：選択中サンプルを送信ボタン手前に表示
document.addEventListener('DOMContentLoaded', function () {
  var page = document.querySelector('#page-wholesale_support_order');
  if (!page) return;

  var form = page.querySelector('.section-contact-form-wholesale form');
  if (!form) return;

  var checkboxes = form.querySelectorAll('.sample-selection__checkbox');
  if (!checkboxes.length) return;

  var summary = form.querySelector('.sample-selection__summary');
  if (!summary) return;

  function escapeHtml(text) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function updateSummary() {
    var selected = [];

    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        selected.push(cb.value);
      }
    });

    if (!selected.length) {
      summary.innerHTML = '';
      summary.classList.remove('sample-selection__summary--has-items');
      return;
    }

    var listHtml = selected
      .map(function (title) {
        return '<li>' + escapeHtml(title) + '</li>';
      })
      .join('');

    summary.innerHTML =
      '<p class="sample-selection__summary-title">ご選択中のサンプル</p>' +
      '<ul class="sample-selection__summary-list">' + listHtml + '</ul>';

    summary.classList.add('sample-selection__summary--has-items');
  }

  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', updateSummary);
  });

  // 初期表示
  updateSummary();
});